// extracted by mini-css-extract-plugin
module.exports = {"socials":"SocialFooter_socials__7ZgX1","twitter":"SocialFooter_twitter__aRg3_","slack":"SocialFooter_slack__NVj5P","newsletterContainer":"SocialFooter_newsletterContainer__Zfdab"};